import { get, post } from './base'

interface ILabelFaxParams {
  page: number
  size: number
  labelId: number

  query?: string
  orderBy?: string
  direction?: string
}

const labelApi = {
  /**
   *
   * @param labelName string 不传则所有标签
   */
  getLabelList(labelName?: string) {
    return get('api/faxLabel/findByName', { labelName })
  },

  //获取该标签fax
  getFaxListByLabel(data: ILabelFaxParams) {
    return get('api/payload/fax/findByLabelWeb', data)
  },

  //添加标签
  addLabel(labelName: string) {
    return post('api/faxLabel/add', { labelName })
  },

  //编辑标签
  editLabel(data: { labelId: string; labelName: string }) {
    return post('api/faxLabel/update', data)
  },
  //删除标签
  deleteLabel(id: number) {
    return post('api/faxLabel/delete', { id })
  },

  //标记标签
  addFaxToLabel(faxLogId: number | string, labelIdList: number[]) {
    return post('api/fax/markLabel', { faxLogId, labelIdList })
  },
}

export default labelApi
